import type { DataGridProps, GridColDef, GridValidRowModel } from '@mui/x-data-grid';
import { DataGrid } from '@mui/x-data-grid';
import type { ReactNode } from 'react';
import { PinnedTopRow, PinnedTopRowContext } from './PinnedTopRow';

interface TableDGProps extends DataGridProps {
  pinnedTopRow?: GridValidRowModel | undefined;
}

function fillAvailableWidth(columns: readonly GridColDef[]): GridColDef[] {
  return columns.map((column) => {
    if (column.width !== undefined || column.flex !== undefined) return column;
    return { ...column, flex: 1 };
  });
}

export function TableDG({ pinnedTopRow, ...props }: TableDGProps): ReactNode {
  return (
    <PinnedTopRowContext.Provider value={pinnedTopRow}>
      <DataGrid
        {...props}
        columns={fillAvailableWidth(props.columns)}
        slots={{ pinnedRows: PinnedTopRow, ...props.slots }}
      />
    </PinnedTopRowContext.Provider>
  );
}
